/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CatalogService
 */
export interface CatalogService {
  /**
   *
   * @type {number}
   * @memberof CatalogService
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof CatalogService
   */
  name: string
  /**
   *
   * @type {boolean}
   * @memberof CatalogService
   */
  isVisible?: boolean | null
  /**
   *
   * @type {string}
   * @memberof CatalogService
   */
  readonly catalogUniqueId: string
  /**
   *
   * @type {Array<any>}
   * @memberof CatalogService
   */
  readonly children: Array<any> | null
}

/**
 * Check if a given object implements the CatalogService interface.
 */
export function instanceOfCatalogService(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'name' in value
  isInstance = isInstance && 'catalogUniqueId' in value
  isInstance = isInstance && 'children' in value

  return isInstance
}

export function CatalogServiceFromJSON(json: any): CatalogService {
  return CatalogServiceFromJSONTyped(json, false)
}

export function CatalogServiceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CatalogService {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    isVisible: !exists(json, 'isVisible') ? undefined : json['isVisible'],
    catalogUniqueId: json['catalogUniqueId'],
    children: json['children'],
  }
}

export function CatalogServiceToJSON(value?: CatalogService | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    isVisible: value.isVisible,
  }
}
